import { render, staticRenderFns } from "./HowToUseLoyalty.vue?vue&type=template&id=537f5c16&"
import script from "./HowToUseLoyalty.vue?vue&type=script&lang=js&"
export * from "./HowToUseLoyalty.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports